<template>
	<div class="contents">
		<div
			v-if="hasImageUrl"
			class="image"
			:class="{
				'border-white': optionIsSelected && !hasImageUrl,
				'border-grey': !optionIsSelected && !hasImageUrl
			}"
		>
			<img
				v-if="item.image"
				:src="item.image"
				:alt="item.image"
			>
			<Icon
				v-else-if="item.icon"
				:icon-name="item.icon"
				:class="{'text-white': optionIsSelected}"
				size="lg"
			/>
		</div>
		<div
			:class="{'text-white': optionIsSelected}"
			class="ml-2 flex-grow"
		>
			{{ item.label }}
		</div>
		<div>
			<Icon
				v-show="optionIsSelected"
				class="dropdown-item-check"
				icon-name="check"
				size="lg"
			/>
		</div>
	</div>
</template>

<script>

export default {
	name:  'ListItem',
	props: {
		item: {
			type:     Object,
			required: true,
		},
		isSelected: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		optionIsSelected() {
			return this.isSelected;
		},
		hasImageUrl() {
			return this.item.image || this.item.icon;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.dropdown-item-check {
	color: var(--color-hype-yellow);
	margin-right: 31.5px;
}

.text-white {
	color: var(--color-white);
}

.image {
	width: 48px;
	height: 48px;
	background: var(--color-grey-800);
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;

	&.border-white {
		border: solid 1px var(--color-soft-white);
	}

	&.border-grey {
		border: solid 1px var(--color-grey-300);
	}

	img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		object-fit: cover;
	}
}
</style>
